import React, { FC } from 'react'

const ElementsToggleIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        className={className}
    >
        <path d="M13 18V15H9V5H7V8H0V0H7V3H13V0H20V8H13V5H11V13H13V10H20V18H13ZM15 6H18V2H15V6ZM15 16H18V12H15V16ZM2 6H5V2H2V6Z" />
    </svg>
)
export default ElementsToggleIcon
